var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
      },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          d: "M11.363 16c-.626 1.214-1.727 2-3.363 2-2.761 0-4-2.239-4-5s1.239-5 4-5c1.636 0 2.737.786 3.363 2M15.5 12.5s.948-.5 2-.5 2.5.5 2.5 2v2c0 1.5.5 2 .5 2",
          stroke: "#000",
          "stroke-width": "2",
          "stroke-linecap": "round",
        },
      }),
      _c("path", {
        attrs: {
          d: "M20 16.955c-1 .978-5 1.989-5-.455 0-1.955 5-1.989 5-.034M19 9l1-1.5",
          stroke: "#000",
          "stroke-width": "2",
          "stroke-linecap": "round",
        },
      }),
      _c("path", {
        attrs: {
          d: "M6 3.5L8 5l2-1.5",
          stroke: "#000",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }